import type { ReactNode } from 'react';

interface Props {
  children: ReactNode;
  className?: string;
}

export default function Card({ children, className = '' }: Props) {
  return (
    <div
      className={`rounded-2xl bg-brand-paper-warm shadow-card p-8 sm:p-10 flex flex-col items-center text-center ${className}`}
    >
      {children}
    </div>
  );
}
